import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';
import type { FreemiumFeaturesModalData } from 'reactApp/sections/FamilyPage/FreemiumFeaturesModal/FreemiumFeaturesModal.types';

export const openFreemiumAboutModal = () => openPopupHelper({ popupName: popupNames.FREEMIUM_ABOUT_MODAL, onClose: () => {} });

export const openFreemiumFeaturesModal = (data: FreemiumFeaturesModalData) =>
    openPopupHelper({ popupName: popupNames.FREEMIUM_FEATURES_MODAL, onClose: () => {}, data });

export const openFreemiumUnlimitedSpaceModal = () =>
    openPopupHelper({ popupName: popupNames.FREEMIUM_UNLIMITED_SPACE_MODAL, onClose: () => {} });
